import colors from "../../assets/theme/light/colors";
import Mnemonics from "../../Mnemonics.json";
import CustomTooltip from "../Tooltip";

export const HomeIcon = ({ color }) => {
	return (
		<svg
			width="14"
			height="13"
			viewBox="0 0 14 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0 13V4.35419L7 0L14 4.35419V13H8.808V7.74253H5.192V13H0Z"
				fill={color}
			/>
		</svg>
	);
};

export const DashboardRefreshIcon = () => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="16" cy="16" r="16" fill={colors.light_logo_blue} />
			<path
				d="M21.1915 12.992C20.462 11.7329 19.2997 10.7818 17.9211 10.3159C16.5426 9.84995 15.0417 9.90089 13.6979 10.4592C12.3541 11.0176 11.259 12.0452 10.6165 13.3509C9.974 14.6566 9.82791 16.1512 10.2054 17.5566C10.5829 18.9619 11.4583 20.1822 12.6686 20.9901C13.8789 21.7981 15.3415 22.1387 16.7842 21.9485C18.2269 21.7583 19.5513 21.0503 20.5108 19.9563C21.4703 18.8623 21.9996 17.4569 22 16.0017"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.25 13.0016H21.25V10.0016"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const RightArrow = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-arrow-narrow-right"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke="#000000"
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M5 12l14 0" />
			<path d="M15 16l4 -4" />
			<path d="M15 8l4 4" />
		</svg>
	);
};

export const PasswordIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-lock-square-rounded"
			width="22"
			height="22"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
			<path d="M8 11m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z" />
			<path d="M10 11v-2a2 2 0 1 1 4 0v2" />
		</svg>
	);
};

export const LogOutIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-logout"
			width="22"
			height="22"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
			<path d="M9 12h12l-3 -3" />
			<path d="M18 15l3 -3" />
		</svg>
	);
};

export const ChatBotIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-message-chatbot"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
			<path d="M9.5 9h.01" />
			<path d="M14.5 9h.01" />
			<path d="M9.5 13a3.5 3.5 0 0 0 5 0" />
		</svg>
	);
};

export const DashboardIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-device-desktop-analytics"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
			<path d="M7 20h10" />
			<path d="M9 16v4" />
			<path d="M15 16v4" />
			<path d="M9 12v-4" />
			<path d="M12 12v-1" />
			<path d="M15 12v-2" />
			<path d="M12 12v-1" />
		</svg>
	);
};

export const TenantIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-building-skyscraper"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M3 21l18 0" />
			<path d="M5 21v-14l8 -4v18" />
			<path d="M19 21v-10l-6 -4" />
			<path d="M9 9l0 .01" />
			<path d="M9 12l0 .01" />
			<path d="M9 15l0 .01" />
			<path d="M9 18l0 .01" />
		</svg>
	);
};

export const ConfigIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-adjustments-alt"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M4 8h4v4h-4z" />
			<path d="M6 4l0 4" />
			<path d="M6 12l0 8" />
			<path d="M10 14h4v4h-4z" />
			<path d="M12 4l0 10" />
			<path d="M12 18l0 2" />
			<path d="M16 5h4v4h-4z" />
			<path d="M18 4l0 1" />
			<path d="M18 9l0 11" />
		</svg>
	);
};

export const UsersIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-users-group"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
			<path d="M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1" />
			<path d="M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
			<path d="M17 10h2a2 2 0 0 1 2 2v1" />
			<path d="M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
			<path d="M3 13v-1a2 2 0 0 1 2 -2h2" />
		</svg>
	);
};

export const UserIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-user"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
			<path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
		</svg>
	);
};

export const LogsIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-database"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0" />
			<path d="M4 6v6a8 3 0 0 0 16 0v-6" />
			<path d="M4 12v6a8 3 0 0 0 16 0v-6" />
		</svg>
	);
};

export const SuggestionsIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-package"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5" />
			<path d="M12 12l8 -4.5" />
			<path d="M12 12l0 9" />
			<path d="M12 12l-8 -4.5" />
			<path d="M16 5.25l-8 4.5" />{" "}
		</svg>
	);
};

export const ReleasesIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-gift"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
			<path d="M12 8l0 13" />
			<path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7" />
			<path d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5" />
		</svg>
	);
};

export const SysVariablesIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-settings-automation"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
			<path d="M10 9v6l5 -3z" />
		</svg>
	);
};

export const ErrorsIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-exclamation-circle"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
			<path d="M12 9v4" />
			<path d="M12 16v.01" />
		</svg>
	);
};

export const TeamsIcon = ({ color }) => {
	return (
		<svg
			xmlns="
      http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-users"
			width="21"
			height="21"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
			<path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
			<path d="M16 3.13a4 4 0 0 1 0 7.75" />
			<path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
		</svg>
	);
};

export const TimeManagementIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-file-time"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M14 3v4a1 1 0 0 0 1 1h4" />
			<path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
			<path d="M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
			<path d="M12 12.496v1.504l1 1" />
		</svg>
	);
};

export const AttendanceManagementIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-address-book"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z" />
			<path d="M10 16h6" />
			<path d="M13 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
			<path d="M4 8h3" />
			<path d="M4 12h3" />
			<path d="M4 16h3" />
		</svg>
	);
};

export const BoardIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-layout-kanban"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke={color}
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M4 4l6 0" />
			<path d="M14 4l6 0" />
			<path d="M4 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
			<path d="M14 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
		</svg>
	);
};

export const DueCalendarIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-calendar-dot"
			width="16"
			height="16"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke={color}
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5" />
			<path d="M16 3v4" />
			<path d="M8 3v4" />
			<path d="M4 11h16" />
			<path d="M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
		</svg>
	);
};

export const BacklogIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-list-details"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M13 5h8" />
			<path d="M13 9h5" />
			<path d="M13 15h8" />
			<path d="M13 19h5" />
			<path d="M3 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
			<path d="M3 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
		</svg>
	);
};

export const TimeEntryIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-alarm"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
			<path d="M12 10l0 3l2 0" />
			<path d="M7 4l-2.75 2" />
			<path d="M17 4l2.75 2" />
		</svg>
	);
};

export const TimesheetIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-chart-infographic"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M7 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
			<path d="M7 3v4h4" />
			<path d="M9 17l0 4" />
			<path d="M17 14l0 7" />
			<path d="M13 13l0 8" />
			<path d="M21 12l0 9" />
		</svg>
	);
};

export const FavoriteIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-chart-infographic"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
		</svg>
	);
};

export const RequestsIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-transfer-in"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M4 18v3h16v-14l-8 -4l-8 4v3" />
			<path d="M4 14h9" />
			<path d="M10 11l3 3l-3 3" />
		</svg>
	);
};

export const ReportsIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-report-analytics"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
			<path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
			<path d="M9 17v-5" />
			<path d="M12 17v-1" />
			<path d="M15 17v-3" />
		</svg>
	);
};

export const ActivateUserIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-user-check"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
			<path d="M6 21v-2a4 4 0 0 1 4 -4h4" />
			<path d="M15 19l2 2l4 -4" />
		</svg>
	);
};

export const DeactivateUserIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-user-x"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
			<path d="M6 21v-2a4 4 0 0 1 4 -4h3.5" />
			<path d="M22 22l-5 -5" />
			<path d="M17 22l5 -5" />
		</svg>
	);
};

export const EmailIcon = ({ color, strokeWidth }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-mail-forward"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth={strokeWidth ? strokeWidth : "1"}
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5" />
			<path d="M3 6l9 6l9 -6" />
			<path d="M15 18h6" />
			<path d="M18 15l3 3l-3 3" />
		</svg>
	);
};

export const NotificationsIcon = ({ color, secondColor, show, thirdColor }) => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="16" cy="16" r="16" fill={color} />
			<path
				d="M17.96 20.8016C17.8682 21.2537 17.6229 21.6602 17.2657 21.9521C16.9085 22.2441 16.4614 22.4036 16 22.4036C15.5387 22.4036 15.0915 22.2441 14.7343 21.9521C14.3771 21.6602 14.1318 21.2537 14.04 20.8016H17.96ZM15.9984 9.59998C18.5176 9.59998 20.5936 11.468 20.7856 13.884L20.796 14.0624L20.8 14.2416L20.7992 17.1264L21.5624 19.196L21.5824 19.264L21.5952 19.3328L21.5992 19.404C21.5992 19.656 21.4424 19.876 21.1816 19.9696L21.0904 19.996L20.9992 20.004H11.0008C10.9301 20.0038 10.8599 19.991 10.7936 19.9664C10.564 19.8824 10.4128 19.6688 10.408 19.3936L10.4112 19.3L10.4384 19.196L11.1984 17.1288L11.2 14.2344L11.2032 14.0544C11.3016 11.5608 13.4168 9.59998 15.9984 9.59998Z"
				fill={secondColor}
			/>
			{show === true ? (
				<circle cx="26" cy="3" r="2" fill={thirdColor} />
			) : null}
		</svg>
	);
};

export const NewsIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-news"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11" />
			<path d="M8 8l4 0" />
			<path d="M8 12l4 0" />
			<path d="M8 16l4 0" />
		</svg>
	);
};

export const CopyIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-copy"
			width={width ? width : "24"}
			height={height ? height : "24"}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
			<path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
		</svg>
	);
};

export const RefreshIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-reload"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747" />
			<path d="M20 4v5h-5" />
		</svg>
	);
};

export const ExportExcelIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-file-export"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			stroke-width="1"
			stroke={color}
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M14 3v4a1 1 0 0 0 1 1h4" />
			<path d="M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3" />
		</svg>
	);
};

export const RemoveIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-trash-x"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M4 7h16" />
			<path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
			<path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
			<path d="M10 12l4 4m0 -4l-4 4" />
		</svg>
	);
};

export const BillableIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-currency-dollar"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2" />
			<path d="M12 3v3m0 12v3" />
		</svg>
	);
};

export const QuickFilterIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-filter-bolt"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12.991 19.67l-3.991 1.33v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3" />
			<path d="M19 16l-2 3h4l-2 3" />
		</svg>
	);
};

export const FilterIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-filter"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z" />
		</svg>
	);
};

export const AppliedFiltersIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-filter-check"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M11.18 20.274l-2.18 .726v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3" />
			<path d="M15 19l2 2l4 -4" />
		</svg>
	);
};

export const UnlockIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-lock-open"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M5 11m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
			<path d="M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
			<path d="M8 11v-5a4 4 0 0 1 8 0" />
		</svg>
	);
};

export const EditColumnsIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-table-options"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7" />
			<path d="M3 10h18" />
			<path d="M10 3v18" />
			<path d="M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
			<path d="M19.001 15.5v1.5" />
			<path d="M19.001 21v1.5" />
			<path d="M22.032 17.25l-1.299 .75" />
			<path d="M17.27 20l-1.3 .75" />
			<path d="M15.97 17.25l1.3 .75" />
			<path d="M20.733 20l1.3 .75" />
		</svg>
	);
};

export const AlertIcon = ({ color, width, height, title }) => {
	return (
		<CustomTooltip title={title}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				className="icon icon-tabler icon-tabler-alert-triangle"
				width={width ? width : "20"}
				height={height ? height : "20"}
				viewBox="0 0 24 24"
				strokeWidth="1.5"
				stroke={color}
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path d="M12 9v4" />
				<path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
				<path d="M12 16h.01" />
			</svg>
		</CustomTooltip>
	);
};

export const ExclamationIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-exclamation-circle"
			width="32"
			height="32"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
			<path d="M12 9v4" />
			<path d="M12 16v.01" />
		</svg>
	);
};

export const CheckIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-circle-check"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
			<path d="M9 12l2 2l4 -4" />
		</svg>
	);
};

export const UncheckIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-circle-x"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
			<path d="M10 10l4 4m0 -4l-4 4" />
		</svg>
	);
};

export const UndoIcon = ({ color }) => {
	return (
		<svg
			fill="none"
			height="22"
			viewBox="0 0 24 24"
			width="22"
			stroke="var(--color--light-logo-blue)"
			strokeWidth="1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g fill={color}>
				<path d="m12.5 14.75h-2.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.5c2.62 0 4.75-2.13 4.75-4.75s-2.13-4.75-4.75-4.75h-5c-2.62 0-4.75 2.13-4.75 4.75 0 1.1.39 2.17 1.09 3.02.26.32.22.79-.1 1.06-.32.26-.79.22-1.06-.1-.92-1.12-1.43-2.53-1.43-3.98 0-3.45 2.8-6.25 6.25-6.25h5c3.45 0 6.25 2.8 6.25 6.25s-2.8 6.25-6.25 6.25z" />
				<path d="m16.5 21.75h-5c-3.45 0-6.25-2.8-6.25-6.25s2.8-6.25 6.25-6.25h2.5c.41 0 .75.34.75.75s-.34.75-.75.75h-2.5c-2.62 0-4.75 2.13-4.75 4.75s2.13 4.75 4.75 4.75h5c2.62 0 4.75-2.13 4.75-4.75 0-1.1-.39-2.17-1.09-3.02-.26-.32-.22-.79.1-1.06s.79-.22 1.06.1c.93 1.12 1.44 2.53 1.44 3.98-.01 3.45-2.81 6.25-6.26 6.25z" />
			</g>
		</svg>
	);
};

export const HelpHexIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-help-hexagon"
			width="30"
			height="30"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z" />
			<path d="M12 16v.01" />
			<path d="M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483" />
		</svg>
	);
};

export const EnableChatIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-message-circle"
			width="16"
			height="16"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1" />
		</svg>
	);
};

export const DisableChatIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-message-circle-off"
			width="16"
			height="16"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M8.595 4.577c3.223 -1.176 7.025 -.61 9.65 1.63c2.982 2.543 3.601 6.523 1.636 9.66m-1.908 2.109c-2.787 2.19 -6.89 2.666 -10.273 1.024l-4.7 1l1.3 -3.9c-2.229 -3.296 -1.494 -7.511 1.68 -10.057" />
			<path d="M3 3l18 18" />
		</svg>
	);
};

export const PreviousIcon = ({ color, onClick = () => {} }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-caret-left"
			width="19"
			height="19"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill={color}
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={onClick}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M14 6l-6 6l6 6v-12" />
		</svg>
	);
};

export const NextIcon = ({ color, onClick = () => {} }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-caret-right"
			width="19"
			height="19"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill={color}
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={onClick}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M10 18l6 -6l-6 -6v12" />
		</svg>
	);
};

export const SaveIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-device-floppy"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" />
			<path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
			<path d="M14 4l0 4l-6 0l0 -4" />
		</svg>
	);
};

export const VoterIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-file-like"
			width="22"
			height="22"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M3 16m0 1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1z" />
			<path d="M6 20a1 1 0 0 0 1 1h3.756a1 1 0 0 0 .958 -.713l1.2 -3c.09 -.303 .133 -.63 -.056 -.884c-.188 -.254 -.542 -.403 -.858 -.403h-2v-2.467a1.1 1.1 0 0 0 -2.015 -.61l-1.985 3.077v4z" />
			<path d="M14 3v4a1 1 0 0 0 1 1h4" />
			<path d="M5 12.1v-7.1a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.3" />
		</svg>
	);
};

export const NeedsReviewIcon = ({
	color,
	height = null,
	viewBox = null,
	title,
	Tooltip,
}) => {
	return (
		<Tooltip title={title}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				className="icon icon-tabler icon-tabler-exclamation-mark"
				width="24"
				height={height != null ? height : "24"}
				viewBox={viewBox != null ? viewBox : "0 0 24 24"}
				strokeWidth="1.5"
				stroke={color}
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path d="M12 19v.01" />
				<path d="M12 15v-10" />
			</svg>
		</Tooltip>
	);
};

export const FilledLikeIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-thumb-up"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill={color}
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3" />
		</svg>
	);
};

export const OutlinedLikeIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-thumb-up"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3" />
		</svg>
	);
};

export const FilledStarIcon = ({ color, handleClick }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-star"
			width="26"
			height="26"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill={color}
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={() => {
				if (handleClick) handleClick(false);
			}}
			style={{ cursor: "pointer" }}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
		</svg>
	);
};

export const OutlinedStarIcon = ({ color, handleClick }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-star"
			width="26"
			height="26"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={() => handleClick(true)}
			style={{ cursor: "pointer" }}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
		</svg>
	);
};

export function getWorkType(type, width = "16", height = "16") {
	if (!type) return null;

	switch (type) {
		case Mnemonics.WorkTypes.workfromhome:
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="icon icon-tabler icon-tabler-home"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					strokeWidth="1.5"
					stroke="currentColor"
					fill="none"
					strokeLinecap="round"
					strokeLinejoin="round"
					color="purple"
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none" />
					<path d="M5 12l5-5 5 5v7a2 2 0 0 1-2 2h-6a2 2 0 0 1-2 -2z" />
					<path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
				</svg>
			);
		case Mnemonics.WorkTypes.workfromoffice:
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="icon icon-tabler icon-tabler-building"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					strokeWidth="1.5"
					stroke="currentColor"
					fill="none"
					strokeLinecap="round"
					strokeLinejoin="round"
					color={colors.green_color}
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none" />
					<path d="M3 21h18" />
					<path d="M5 21v-14l5 0v-4h4v4l5 0v14" />
					<path d="M9 8v3h1" />
					<path d="M9 14v3h1" />
					<path d="M14 8v3h1" />
					<path d="M14 14v3h1" />
				</svg>
			);
		case Mnemonics.WorkTypes.workfromsite:
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="icon icon-tabler icon-tabler-tool"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					strokeWidth="1.5"
					stroke="currentColor"
					fill="none"
					strokeLinecap="round"
					strokeLinejoin="round"
					color={colors.classic_blue}
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none" />
					<path d="M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5" />
				</svg>
			);
		case Mnemonics.WorkTypes.timeoff:
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="icon icon-tabler icon-tabler-calendar-off"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					strokeWidth="1.5"
					stroke="currentColor"
					fill="none"
					strokeLinecap="round"
					strokeLinejoin="round"
					color="#008080"
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none" />
					<path d="M9 5h9a2 2 0 0 1 2 2v9m-.184 3.839a2 2 0 0 1 -1.816 1.161h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.158 -1.815" />
					<path d="M16 3v4" />
					<path d="M8 3v1" />
					<path d="M4 11h7m4 0h5" />
					<path d="M3 3l18 18" />
				</svg>
			);
		case Mnemonics.WorkTypes.traveltime:
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					color={colors.orange_color}
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					width="24"
					height="24"
					stroke-width="1.5"
				>
					{" "}
					<path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>{" "}
					<path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>{" "}
					<path d="M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"></path>{" "}
				</svg>
			);
		default:
			return null;
	}
}

export const ExpandMoreIcon = ({ color, handleClick }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-chevron-down"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={() => {
				if (handleClick !== undefined) handleClick();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M6 9l6 6l6 -6" />
		</svg>
	);
};

export const TableExpandIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-layout-navbar-expand-filled"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path
				d="M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm1 6h-14v9a1 1 0 0 0 .883 .993l.117 .007h12a1 1 0 0 0 .993 -.883l.007 -.117v-9zm-8.387 3.21l.094 .083l1.293 1.292l1.293 -1.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-2 2a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 1.32 -1.497z"
				strokeWidth="0"
				fill="currentColor"
			/>
		</svg>
	);
};

export const TableCollapseIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-layout-bottombar-expand-filled"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path
				d="M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm0 2h-12a1 1 0 0 0 -.993 .883l-.007 .117v9h14v-9a1 1 0 0 0 -.883 -.993l-.117 -.007zm-5.387 3.21l.094 .083l2 2a1 1 0 0 1 -1.32 1.497l-.094 -.083l-1.293 -1.292l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l2 -2a1 1 0 0 1 1.32 -.083z"
				strokeWidth="0"
				fill="currentColor"
			/>
		</svg>
	);
};

export const MaximizeIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-arrows-maximize"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M16 4l4 0l0 4" />
			<path d="M14 10l6 -6" />
			<path d="M8 20l-4 0l0 -4" />
			<path d="M4 20l6 -6" />
			<path d="M16 20l4 0l0 -4" />
			<path d="M14 14l6 6" />
			<path d="M8 4l-4 0l0 4" />
			<path d="M4 4l6 6" />
		</svg>
	);
};

export const MaximizeComponentIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-arrows-diagonal"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke={color}
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M16 4l4 0l0 4" />
			<path d="M14 10l6 -6" />
			<path d="M8 20l-4 0l0 -4" />
			<path d="M4 20l6 -6" />
		</svg>
	);
};

export const MinimizeIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-arrows-minimize"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M5 9l4 0l0 -4" />
			<path d="M3 3l6 6" />
			<path d="M5 15l4 0l0 4" />
			<path d="M3 21l6 -6" />
			<path d="M19 9l-4 0l0 -4" />
			<path d="M15 9l6 -6" />
			<path d="M19 15l-4 0l0 4" />
			<path d="M15 15l6 6" />
		</svg>
	);
};

export const MinimizeComponentIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-arrows-diagonal-minimize-2"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke={color}
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M18 10h-4v-4" />
			<path d="M20 4l-6 6" />
			<path d="M6 14h4v4" />
			<path d="M10 14l-6 6" />
		</svg>
	);
};

export const ExpandLessIcon = ({ color, handleClick }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-chevron-up"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={() => {
				if (handleClick !== undefined) handleClick();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M6 15l6 -6l6 6" />
		</svg>
	);
};

export const ExpandMoreDottedIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-chevron-down"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			<path d="M6 9l6 6l6 -6" stroke-dasharray="1 3"></path>
		</svg>
	);
};

export const ArrowRightIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-chevron-right"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M9 6l6 6l-6 6" />
		</svg>
	);
};

export const ArrowLeftIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-chevron-left"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M15 6l-6 6l6 6" />
		</svg>
	);
};

export const DeleteIcon = ({ color, width, height, style }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-trash"
			width={width ? width : "24"}
			height={height ? height : "24"}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={style}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M4 7l16 0" />
			<path d="M10 11l0 6" />
			<path d="M14 11l0 6" />
			<path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
			<path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
		</svg>
	);
};

export const MoveIcon = ({ color, style, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-file-arrow-right"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M14 3v4a1 1 0 0 0 1 1h4" />
			<path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
			<path d="M9 15h6" />
			<path d="M12.5 17.5l2.5 -2.5l-2.5 -2.5" />
		</svg>
	);
};

export const SubtaskIcon = ({ color, handleClick, Tooltip, t }) => {
	return Tooltip !== undefined && Tooltip !== null ? (
		<Tooltip title={t("dashboard.subtask.addNew")}>
			<svg
				fill="none"
				width="24"
				height="24"
				strokeWidth="1.5"
				viewBox="-3 -3 30 30"
				xmlns="http://www.w3.org/2000/svg"
				style={{
					cursor: "pointer",
					border: `1px solid ${color}`,
					borderRadius: "50px",
				}}
				onClick={(e) => {
					if (handleClick !== undefined) handleClick();
					else e.preventDefault();
				}}
			>
				<g stroke={color}>
					<rect
						height="4"
						rx="2"
						transform="matrix(0 1 -1 0 25 -7)"
						width="4"
						x="16"
						y="9"
					/>
					<rect
						height="4"
						rx="2"
						transform="matrix(0 1 -1 0 37 -3)"
						width="4"
						x="20"
						y="17"
					/>
					<path d="m5 4v11c0 1.8856 0 2.8284.58579 3.4142.58578.5858 1.52859.5858 3.41421.5858h7" />
					<path d="m5 7c0 1.88562 0 2.82843.58579 3.4142.58578.5858 1.52859.5858 3.41421.5858h3" />
				</g>
			</svg>
		</Tooltip>
	) : (
		<>
			<svg
				fill="none"
				width="24"
				height="24"
				strokeWidth="1.5"
				viewBox="-3 -3 30 30"
				xmlns="http://www.w3.org/2000/svg"
				style={{
					cursor: "pointer",
					border: `1px solid ${color}`,
					borderRadius: "50px",
				}}
				onClick={(e) => {
					if (handleClick !== undefined) handleClick();
					else e.preventDefault();
				}}
			>
				<g stroke={color}>
					<rect
						height="4"
						rx="2"
						transform="matrix(0 1 -1 0 25 -7)"
						width="4"
						x="16"
						y="9"
					/>
					<rect
						height="4"
						rx="2"
						transform="matrix(0 1 -1 0 37 -3)"
						width="4"
						x="20"
						y="17"
					/>
					<path d="m5 4v11c0 1.8856 0 2.8284.58579 3.4142.58578.5858 1.52859.5858 3.41421.5858h7" />
					<path d="m5 7c0 1.88562 0 2.82843.58579 3.4142.58578.5858 1.52859.5858 3.41421.5858h3" />
				</g>
			</svg>
		</>
	);
};

export const ShowDetailsIcon = ({ color, disabled, handleClick }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-zoom-in"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined && !disabled) handleClick();
				else e.preventDefault();
			}}
			style={{
				cursor: disabled === true ? "default" : "pointer",
				marginBottom: "-5px",
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
			<path d="M7 10l6 0" />
			<path d="M10 7l0 6" />
			<path d="M21 21l-6 -6" />
		</svg>
	);
};

export const AddIcon = ({
	color,
	width,
	height,
	handleClick,
	disabled = false,
}) => {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={width ? width : "18"}
				height={height ? height : "18"}
				viewBox="0 0 24 24"
				fill="none"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				class="lucide lucide-plus-circle h-5 w-5"
				onClick={(e) => {
					if (!disabled) {
						if (handleClick !== undefined) handleClick();
						else e.preventDefault();
					}
				}}
				style={{
					cursor: "pointer",
					marginBottom: "-5px",
				}}
			>
				<circle cx="12" cy="12" r="10"></circle>
				<path d="M8 12h8"></path>
				<path d="M12 8v8"></path>
			</svg>
		</>
	);
};

export const CloseIcon = ({ color, stroke, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-x"
			width={width ? width : "24"}
			height={width ? width : "24"}
			viewBox="0 0 24 24"
			strokeWidth={stroke}
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M18 6l-12 12" />
			<path d="M6 6l12 12" />
		</svg>
	);
};

export const ExternalReferenceIcon = ({ color, handleClick }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-external-link"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined) handleClick();
				else e.preventDefault();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
			<path d="M11 13l9 -9" />
			<path d="M15 4h5v5" />
		</svg>
	);
};

export const ProjectIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			id="Layer_1"
			width="40"
			height="40"
			fill={color}
			x="0px"
			y="0px"
			viewBox="-40 -20 200 200"
		>
			<g>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M105.4,76.3l3.8,3.8c1,1,1,2.6,0,3.6l-3.1,3.1c0.8,1.6,1.5,3.3,1.9,5.1h4c1.4,0,2.6,1.2,2.6,2.6v5.4 c0,1.4-1.2,2.6-2.6,2.6h-4.3c-0.5,1.7-1.3,3.4-2.2,4.9l2.8,2.8c1,1,1,2.6,0,3.6l-3.8,3.8c-1,1-2.6,1-3.6,0l-3.1-3.1 c-1.6,0.8-3.3,1.5-5.1,1.9v4c0,1.4-1.2,2.6-2.6,2.6h-5.4c-1.4,0-2.6-1.2-2.6-2.6V116c-1.7-0.5-3.4-1.3-4.9-2.2l-2.8,2.8 c-1,1-2.6,1-3.6,0l-3.8-3.8c-1-1-1-2.6,0-3.6l3.1-3.1c-0.8-1.6-1.5-3.3-1.9-5.1h-4c-1.4,0-2.6-1.2-2.6-2.6v-5.4 c0-1.4,1.2-2.6,2.6-2.6h4.3c0.5-1.7,1.3-3.4,2.2-4.9L68,82.8c-1-1-1-2.6,0-3.6l3.8-3.8c1-1,2.6-1,3.6,0l3.1,3.1 c1.6-0.8,3.3-1.5,5.1-1.9v-4c0-1.4,1.2-2.6,2.6-2.6h5.4c1.4,0,2.6,1.2,2.6,2.6v4.3c1.7,0.5,3.4,1.3,4.9,2.2l2.8-2.8 C102.7,75.3,104.4,75.3,105.4,76.3L105.4,76.3L105.4,76.3z M41.4,82.2c-1.4,0-2.5-1.4-2.5-3c0-1.7,1.1-3,2.5-3h12.4 c1.4,0,2.5,1.4,2.5,3c0,1.7-1.1,3-2.5,3H41.4L41.4,82.2L41.4,82.2z M45.1,112.3c1.7,0,3,1.4,3,3c0,1.7-1.4,3-3,3h-38 c-1.9,0-3.7-0.8-5-2.1c-1.3-1.3-2.1-3-2.1-5V7.1c0-2,0.8-3.7,2.1-5c1.3-1.3,3-2.1,5-2.1h86.7c1.9,0,3.7,0.8,5,2.1 c1.3,1.3,2.1,3,2.1,5v48.3c0,1.7-1.4,3-3,3c-1.7,0-3-1.4-3-3V7.1c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3H7.1 c-0.3,0-0.5,0.1-0.7,0.3C6.2,6.5,6.1,6.8,6.1,7.1v104.3c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3H45.1L45.1,112.3L45.1,112.3 z M18.8,74.1h10.7c0.6,0,1,0.4,1,1v9.2c0,0.6-0.4,1-1,1H18.8c-0.6,0-1-0.4-1-1v-9.2C17.8,74.5,18.2,74.1,18.8,74.1L18.8,74.1 L18.8,74.1z M18.8,21.2h10.7c0.6,0,1,0.4,1,1v9.2c0,0.6-0.4,1-1,1H18.8c-0.6,0-1-0.4-1-1v-9.2C17.8,21.6,18.2,21.2,18.8,21.2 L18.8,21.2L18.8,21.2z M41.4,29.3c-1.4,0-2.5-1.4-2.5-3c0-1.7,1.1-3,2.5-3h34.7c1.4,0,2.5,1.4,2.5,3c0,1.7-1.1,3-2.5,3H41.4 L41.4,29.3L41.4,29.3z M21.9,57.4c-0.7,0.5-1.6,0.4-2.3-0.3c-0.1-0.1-0.1-0.1-0.2-0.2l-3.2-3.3c-0.7-0.7-0.5-1.8,0.3-2.6 c0.9-0.7,2.1-0.8,2.8-0.1l1.7,1.8l5.6-4.5c0.7-0.6,1.9-0.3,2.5,0.6c0.7,0.9,0.6,2.2-0.2,2.8L21.9,57.4L21.9,57.4L21.9,57.4z M39.7,54.8c-1.4,0-2.5-1.4-2.5-3c0-1.7,1.1-3,2.5-3h34.7c1.4,0,2.5,1.4,2.5,3c0,1.7-1.1,3-2.5,3H39.7L39.7,54.8L39.7,54.8z M88.1,85.9c5.8,0,10.6,4.7,10.6,10.6c0,5.8-4.7,10.6-10.6,10.6c-5.8,0-10.6-4.7-10.6-10.6C77.5,90.6,82.3,85.9,88.1,85.9 L88.1,85.9L88.1,85.9z"
				/>
			</g>
		</svg>
	);
};

export const TaskIcon = ({ style }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-square-check"
			width="18"
			height="18"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke="#A58A08"
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={style}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
			<path d="M9 12l2 2l4 -4" />
		</svg>
	);
};

export const AddIconOutlined = ({
	color,
	handleClick,
	title,
	Tooltip,
	width,
	height,
}) => {
	return Tooltip !== undefined && Tooltip !== null ? (
		<Tooltip title={title}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				class="icon icon-tabler icon-tabler-plus"
				width={width ? width : "24"}
				height={height ? height : "24"}
				viewBox="0 0 28 28"
				strokeWidth="1"
				stroke={color}
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round"
				onClick={(e) => {
					if (handleClick !== undefined) handleClick();
					else e.preventDefault();
				}}
			>
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path d="M12 5l0 14" />
				<path d="M5 12l14 0" />
			</svg>
		</Tooltip>
	) : (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-plus"
			width={width ? width : "24"}
			height={height ? height : "24"}
			viewBox="0 0 28 28"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined) handleClick();
				else e.preventDefault();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 5l0 14" />
			<path d="M5 12l14 0" />
		</svg>
	);
};

export const SubtaskIconOutlined = ({ color, handleClick, title, Tooltip }) => {
	return Tooltip !== undefined && Tooltip !== null ? (
		<Tooltip title={title}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				class="icon icon-tabler icon-tabler-subtask"
				width="24"
				height="24"
				viewBox="0 0 28 28"
				strokeWidth="1.5"
				stroke={color}
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round"
				onClick={(e) => {
					if (handleClick !== undefined) handleClick();
					else e.preventDefault();
				}}
			>
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path d="M6 9l6 0" />
				<path d="M4 5l4 0" />
				<path d="M6 5v11a1 1 0 0 0 1 1h5" />
				<path d="M12 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z" />
				<path d="M12 15m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z" />
			</svg>
		</Tooltip>
	) : (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-subtask"
			width="24"
			height="24"
			viewBox="0 0 28 28"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined) handleClick();
				else e.preventDefault();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M6 9l6 0" />
			<path d="M4 5l4 0" />
			<path d="M6 5v11a1 1 0 0 0 1 1h5" />
			<path d="M12 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z" />
			<path d="M12 15m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z" />
		</svg>
	);
};

export const AddTimeIcon = ({
	color,
	width,
	height,
	handleClick,
	title,
	Tooltip,
}) => {
	return Tooltip !== undefined && Tooltip !== null ? (
		<Tooltip title={title}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				class="icon icon-tabler icon-tabler-clock-edit"
				width={width ? width : "24"}
				height={height ? height : "24"}
				viewBox="0 0 28 28"
				strokeWidth="1.5"
				stroke={color}
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round"
				onClick={(e) => {
					if (handleClick !== undefined) handleClick();
					else e.preventDefault();
				}}
			>
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path d="M21 12a9 9 0 1 0 -9.972 8.948c.32 .034 .644 .052 .972 .052" />
				<path d="M12 7v5l2 2" />
				<path d="M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z" />
			</svg>
		</Tooltip>
	) : (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-clock-edit"
			width={width ? width : "24"}
			height={height ? height : "24"}
			viewBox="0 0 28 28"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined) handleClick();
				else e.preventDefault();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M21 12a9 9 0 1 0 -9.972 8.948c.32 .034 .644 .052 .972 .052" />
			<path d="M12 7v5l2 2" />
			<path d="M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z" />
		</svg>
	);
};

export const ExpandLeftIcon = ({ color, handleClick, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-arrow-bar-to-right"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined) handleClick();
				else e.preventDefault();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M14 12l-10 0" />
			<path d="M14 12l-4 4" />
			<path d="M14 12l-4 -4" />
			<path d="M20 4l0 16" />
		</svg>
	);
};

export const CollapseRightIcon = ({ color, handleClick, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-arrow-bar-to-left"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined) handleClick();
				else e.preventDefault();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M10 12l10 0" />
			<path d="M10 12l4 4" />
			<path d="M10 12l4 -4" />
			<path d="M4 4l0 16" />
		</svg>
	);
};

export const ActionsIcon = ({ color, handleClick, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-dots"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined) handleClick(e);
				else e.preventDefault();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
			<path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
			<path d="M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
		</svg>
	);
};

export const VerticalActionsIcon = ({ color, handleClick }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-dots-vertical"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1.8"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined) handleClick(e);
				else e.preventDefault();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
			<path d="M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
			<path d="M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
		</svg>
	);
};

export const HourGlassIcon = ({ color, handleClick, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-hourglass-empty"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			onClick={(e) => {
				if (handleClick !== undefined) handleClick(e);
				else e.preventDefault();
			}}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z" />
			<path d="M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z" />
		</svg>
	);
};

export const GetUserImage = ({ url, width, height, style, alt }) => {
	return (
		<img
			src={url || alt}
			width={width}
			height={height}
			style={style}
			onError={({ currentTarget }) => {
				currentTarget.onerror = null;
				currentTarget.src = alt;
			}}
		/>
	);
};

export const getTeamImage = ({ url, width, height }) => {
	return <img src={url} width={width} height={height} />;
};

export const getOptionPriorityIcon = (option, style) => {
	switch (option) {
		case "High":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="icon icon-tabler icon-tabler-flag"
					width="20"
					height="20"
					viewBox="0 0 24 24"
					strokeWidth="1.5"
					stroke="var(--color-statuses-error-color)"
					fill="var(--color-statuses-error-color)"
					strokeLinecap="round"
					strokeLinejoin="round"
					style={style}
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none" />
					<path d="M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1 -7 0a5 5 0 0 0 -7 0v-9z" />
					<path d="M5 21v-7" />
				</svg>
			);
		case "Medium":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="icon icon-tabler icon-tabler-flag"
					width="20"
					height="20"
					viewBox="0 0 24 24"
					strokeWidth="1.5"
					stroke="var(--color-employeeStatusColors-new-color)"
					fill="var(--color-employeeStatusColors-new-color)"
					strokeLinecap="round"
					strokeLinejoin="round"
					style={style}
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none" />
					<path d="M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1 -7 0a5 5 0 0 0 -7 0v-9z" />
					<path d="M5 21v-7" />
				</svg>
			);
		case "Low":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="icon icon-tabler icon-tabler-flag"
					width="20"
					height="20"
					viewBox="0 0 24 24"
					strokeWidth="1.5"
					stroke="rgba(0, 138, 214, 1)"
					fill="rgba(0, 138, 214, 1)"
					strokeLinecap="round"
					strokeLinejoin="round"
					style={style}
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none" />
					<path d="M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1 -7 0a5 5 0 0 0 -7 0v-9z" />
					<path d="M5 21v-7" />
				</svg>
			);

		default:
			return null;
	}
};

export const ExcelIcon = () => {
	return (
		<svg
			version="1.1"
			id="Livello_1"
			xmlns="http://www.w3.org/2000/svg"
			width="30"
			height="30"
			x="0px"
			y="0px"
			viewBox="0 0 512 512"
			style={{ enableBackground: "new 0 0 512 512" }}
		>
			<path
				class="st0"
				fill="#185C37"
				d="M321.49,244.09l-202.42-35.72v263.94c0,12.05,9.77,21.83,21.83,21.83l0,0h349.28	c12.05,0,21.83-9.77,21.83-21.83l0,0v-97.24L321.49,244.09z"
			/>
			<path
				class="st1"
				fill="#21A366"
				d="M321.49,17.86H140.9c-12.05,0-21.83,9.77-21.83,21.83l0,0v97.24L321.49,256l107.16,35.72L512,256V136.93	L321.49,17.86z"
			/>
			<path
				class="st2"
				fill="#107C41"
				d="M119.07,136.93h202.42V256H119.07V136.93z"
			/>
			<path
				class="st3"
				opacity="0.1"
				enableBackground="new"
				d="M263.94,113.12H119.07v297.67h144.87c12.04-0.04,21.79-9.79,21.83-21.83V134.94	C285.73,122.9,275.98,113.16,263.94,113.12z"
			/>
			<path
				class="st4"
				opacity="0.2"
				enable-background="new"
				d="M252.04,125.02H119.07V422.7h132.97c12.04-0.04,21.79-9.79,21.83-21.83V146.85	C273.82,134.81,264.07,125.06,252.04,125.02z"
			/>
			<path
				class="st4"
				opacity="0.2"
				enableBackground="new"
				d="M252.04,125.02H119.07v273.86h132.97c12.04-0.04,21.79-9.79,21.83-21.83V146.85	C273.82,134.81,264.07,125.06,252.04,125.02z"
			/>
			<path
				class="st4"
				opacity="0.2"
				enableBackground="new"
				d="M240.13,125.02H119.07v273.86h121.06c12.04-0.04,21.79-9.79,21.83-21.83V146.85	C261.91,134.81,252.17,125.06,240.13,125.02z"
			/>
			<linearGradient
				id="SVGID_1_"
				gradientUnits="userSpaceOnUse"
				x1="45.5065"
				y1="-1464.0308"
				x2="216.4467"
				y2="-1167.9695"
				gradientTransform="matrix(1 0 0 1 0 1572)"
			>
				<stop offset="0" style={{ stopColor: "#18884F" }} />
				<stop offset="0.5" style={{ stopColor: "#117E43" }} />
				<stop offset="1" style={{ stopColor: "#0B6631" }} />
			</linearGradient>
			<path
				class="st5"
				fill="url(#SVGID_1_)"
				d="M21.83,125.02h218.3c12.05,0,21.83,9.77,21.83,21.83v218.3c0,12.05-9.77,21.83-21.83,21.83H21.83	C9.77,386.98,0,377.21,0,365.15v-218.3C0,134.79,9.77,125.02,21.83,125.02z"
			/>
			<path
				class="st6"
				fill="#FFFFFF"
				d="M67.6,326.94l45.91-71.14l-42.07-70.75h33.84l22.96,45.25c2.12,4.3,3.57,7.49,4.36,9.6h0.3	c1.51-3.43,3.1-6.76,4.76-9.99l24.54-44.83h31.07l-43.14,70.33l44.23,71.54H161.3l-26.52-49.66c-1.25-2.11-2.31-4.33-3.17-6.63	h-0.39c-0.78,2.25-1.81,4.41-3.07,6.43l-27.3,49.87L67.6,326.94L67.6,326.94z"
			/>
			<path
				class="st7"
				fill="#33C481"
				d="M490.17,17.86H321.49v119.07H512V39.69C512,27.63,502.23,17.86,490.17,17.86L490.17,17.86z"
			/>
			<path
				class="st2"
				fill="#107C41"
				d="M321.49,256H512v119.07H321.49V256z"
			/>
		</svg>
	);
};

export const EditIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-edit"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
			<path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
			<path d="M16 5l3 3" />
		</svg>
	);
};

export const HelpIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-help-circle"
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
			<path d="M12 16v.01" />
			<path d="M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483" />
		</svg>
	);
};

export const WarningIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-alert-triangle"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M12 9v4" />
			<path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
			<path d="M12 16h.01" />
		</svg>
	);
};

export const UploadIcon = ({ color, width, height, strokeWidth }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-cloud-upload"
			width={width ? width : "24"}
			height={height ? height : "24"}
			viewBox="0 0 24 24"
			strokeWidth={strokeWidth ? strokeWidth : "1.5"}
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1" />
			<path d="M9 15l3 -3l3 3" />
			<path d="M12 12l0 9" />
		</svg>
	);
};

export const EyeIcon = ({ color, style }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-eye"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={style}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
			<path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
		</svg>
	);
};

export const EditPenIcon = ({ color, width, height, strokeWidth }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-pencil"
			width={width ? width : "24"}
			height={height ? height : "24"}
			viewBox="0 0 24 24"
			strokeWidth={strokeWidth ? strokeWidth : "1.5"}
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
			<path d="M13.5 6.5l4 4" />
		</svg>
	);
};

export const PrintIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-printer"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
			<path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
			<path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z" />
		</svg>
	);
};

export const PDFIcon = () => {
	return (
		<svg
			id="Layer_1"
			dataName="Layer 1"
			xmlns="http://www.w3.org/2000/svg"
			width="80"
			height="80"
			viewBox="0 0 122.88 121.83"
		>
			<path
				class="cls-1"
				fillRule="evenodd"
				d="M102.42,37H81.92a8.52,8.52,0,0,1-8.85-8.7V7.53H21a.58.58,0,0,0-.41.18.45.45,0,0,0-.18.42V113.71a.7.7,0,0,0,.18.41.51.51,0,0,0,.41.18h80.84c.18,0,.17-.09.26-.18s.34-.28.34-.41V37Zm7.47,79.08a5.77,5.77,0,0,1-5.76,5.76H18.66a5.77,5.77,0,0,1-5.76-5.76V5.76a5.7,5.7,0,0,1,1.69-4.07A5.77,5.77,0,0,1,18.66,0H76.9a4.22,4.22,0,0,1,2.46.82l29.75,30.12a2.57,2.57,0,0,1,.78,2.6v82.53ZM80,27.69,79.57,9.63,100.66,31l-18.14-.81A2.4,2.4,0,0,1,80,27.69Z"
			/>
			<path
				class="cls-2"
				fillRule="evenodd"
				fill="red"
				d="M6.71,46.28H116.17A6.73,6.73,0,0,1,122.88,53v45.1a6.73,6.73,0,0,1-6.71,6.71H6.71A6.73,6.73,0,0,1,0,98.09V53a6.73,6.73,0,0,1,6.71-6.71Z"
			/>
			<path
				class="cls-3"
				fill="#fff"
				d="M16.33,59.78h16.2c3.53,0,6.17.83,7.94,2.51s2.63,4.08,2.63,7.18a9.71,9.71,0,0,1-2.88,7.47c-1.91,1.8-4.84,2.69-8.77,2.69H26.1V91.3H16.33V59.78ZM26.1,73.25h2.4a6.22,6.22,0,0,0,4-1,3.17,3.17,0,0,0,1.14-2.51,3.51,3.51,0,0,0-1-2.52c-.66-.69-1.91-1-3.75-1H26.1v7ZM48.3,59.78H62.78a17.47,17.47,0,0,1,6.92,1.16,11.23,11.23,0,0,1,4.35,3.33,13.66,13.66,0,0,1,2.49,5,23.36,23.36,0,0,1,.78,6.11,21.16,21.16,0,0,1-1.15,7.84A13,13,0,0,1,73,87.93a10.38,10.38,0,0,1-4.39,2.51,22.39,22.39,0,0,1-5.81.86H48.3V59.78ZM58,66.91V84.13h2.4a10.16,10.16,0,0,0,4.36-.68,4.65,4.65,0,0,0,2-2.36,14.84,14.84,0,0,0,.73-5.48q0-5-1.63-6.85c-1.09-1.23-2.91-1.85-5.44-1.85Zm24.43-7.13h24.09v6.78H92.24v5.5h12.24v6.39H92.24V91.3H82.46V59.78Z"
			/>
		</svg>
	);
};

export const ReopenIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-rotate-clockwise-2"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke={color}
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5" />
			<path d="M5.63 7.16l0 .01" />
			<path d="M4.06 11l0 .01" />
			<path d="M4.63 15.1l0 .01" />
			<path d="M7.16 18.37l0 .01" />
			<path d="M11 19.94l0 .01" />
		</svg>
	);
};

export const ApproveIconButton = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="green"
			stroke-linecap="round"
			stroke-linejoin="round"
			width="24"
			height="24"
			stroke-width="1.5"
			style={{ marginRight: "5px" }}
		>
			<path d="M5 12l5 5l10 -10"></path>
		</svg>
	);
};

export const ExportIconButton = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			color="#000000"
			viewBox="0 0 24 24"
			fill="green"
			width="24"
			height="20"
			strokeWidth=".5"
		>
			<path d="M2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.495v20.846a.5.5 0 0 1-.57.495L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99zM4 4.735v14.53l10 1.429V3.306L4 4.735zM17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4v-2zm-6.8-7l2.8 4h-2.4L9 13.714 7.4 16H5l2.8-4L5 8h2.4L9 10.286 10.6 8H13l-2.8 4z"></path>
		</svg>
	);
};

export const RequestApprovalIcon = ({ color, width, height }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			color="#000000"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			width="24"
			height="24"
			strokeWidth="1"
		>
			<path d="M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"></path>
			<path d="M3 6l9 6l9 -6"></path>
			<path d="M15 18h6"></path>
			<path d="M18 15l3 3l-3 3"></path>
		</svg>
	);
};

export const GetEntriesIcon = ({ color }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokelinecap="round"
			strokelinejoin="round"
			width={24}
			height={24}
			strokeWidth={2}
		>
			{" "}
			<path d="M6 10l-2 1l8 4l8 -4l-2 -1"></path>{" "}
			<path d="M4 15l8 4l8 -4"></path> <path d="M12 4v7"></path>{" "}
			<path d="M15 8l-3 3l-3 -3"></path>{" "}
		</svg>
	);
};

export const RejectIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="red"
			strokeLinecap="round"
			strokeLinejoin="round"
			width="24"
			height="24"
			strokeWidth="1.5"
			style={{ marginRight: "5px" }}
		>
			<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
			<path d="M5.7 5.7l12.6 12.6" />
		</svg>
	);
};

export const ApproveTimeEntryIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="green"
			stroke-linecap="round"
			stroke-linejoin="round"
			width="24"
			height="24"
			stroke-width="1.5"
			style={{ marginRight: "5px" }}
		>
			<path d="M5 12l5 5l10 -10"></path>
		</svg>
	);
};

export const ClearTimeSheetIcon = ({ color, width, height, style }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="icon icon-tabler icon-tabler-trash"
			width={width ? width : "24"}
			height={height ? height : "24"}
			viewBox="0 0 24 24"
			strokeWidth="1"
			stroke="red"
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={style}
		>
			<path d="M4 7h16" />
			<path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
			<path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
			<path d="M10 12l4 4m0 -4l-4 4" />
		</svg>
	);
};
